import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.586 2a1.5 1.5 0 011.5-1.5h6a1.5 1.5 0 011.5 1.5v10.692a.5.5 0 01-.842.364L6.112 10.59a1.5 1.5 0 00-2.052 0l-2.632 2.467a.5.5 0 01-.842-.364V2z" stroke="#81B5A1" fill="#81B5A1" /></svg>);